import type { ModuleDef } from "../types";
import { defineModule } from "./define";

export const REACTORS: ModuleDef[] = [
  defineModule({
    id: "rtg_small",
    name: "RTG Cell",
    category: "reactor",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "rtg_small",
    stats: {
      mass: 220, hp: 50,
      tensile: 400_000_000,
      hardness: 0.5,
      powerOutW: 4_000,
      energyEfficiency: 0.4,
      thermalConductivity: 1.2,
      thermalEmissivity: 0.4,
      meltPointK: 2_000,
    },
    reactor: { fuelResource: "plutonium", fuelJoulesPerKg: 600_000_000, fuelBufferKg: 0.5 },
  }),
  defineModule({
    id: "fission_mk1",
    name: "Fission Pile Mk.I",
    category: "reactor",
    tier: 2,
    cells: { w: 2, h: 2 },
    sprite: "fission_mk1",
    stats: {
      mass: 1_400, hp: 240,
      tensile: 600_000_000,
      hardness: 0.6,
      crew: 1,
      powerOutW: 75_000_000, powerIdleW: 800,
      energyEfficiency: 0.3,
      thermalConductivity: 1.2,
      thermalEmissivity: 0.3,
      meltPointK: 2_300,
    },
    reactor: { fuelResource: "uranium", fuelJoulesPerKg: 60_000_000, fuelBufferKg: 10 },
  }),
  defineModule({
    id: "battery_mk1",
    name: "Battery Bank Mk.I",
    category: "battery",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "battery_mk1",
    stats: {
      mass: 350, hp: 90,
      tensile: 200_000_000,
      hardness: 0.2,
      batteryWh: 5_000,
      thermalConductivity: 0.7,
      thermalInertia: 1_000,
      thermalEmissivity: 0.5,
      meltPointK: 800,
    },
  }),
  defineModule({
    id: "fuel_tank_mk1",
    name: "Fuel Tank Mk.I",
    category: "fuel",
    tier: 1,
    cells: { w: 2, h: 1 },
    sprite: "fuel_tank_mk1",
    stats: {
      mass: 400, hp: 120,
      tensile: 450_000_000,
      hardness: 0.3,
      fuelCapacityKg: 6_000,
      thermalConductivity: 0.35,
      thermalEmissivity: 0.1,
      meltPointK: 1100,
    },
  }),
];
